import { render } from "./MyMatrimonyListings.vue?vue&type=template&id=e4c881bc"
import script from "./MyMatrimonyListings.vue?vue&type=script&lang=js"
export * from "./MyMatrimonyListings.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__